var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlotoThemeComponent',{attrs:{"portal":"support-portal"}},[_c('MLayout',{staticClass:"loginLayout"},[_c('MLayoutContent',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }